import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    // Obter o serial do link clicado
    const link = event.currentTarget
    const serial = link.dataset.serial
    
    // Atualizar o botão
    const button = document.getElementById('dropdownSearchButton')
    if (button) {
      // Limpar o botão
      button.innerHTML = ''
      
      // Adicionar o texto
      const textNode = document.createTextNode(`WEC - ${serial}`)
      button.appendChild(textNode)
      
      // Adicionar o SVG
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
      svg.setAttribute('class', 'w-2.5 h-2.5 ms-3')
      svg.setAttribute('aria-hidden', 'true')
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
      svg.setAttribute('fill', 'none')
      svg.setAttribute('viewBox', '0 0 10 6')
      
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
      path.setAttribute('stroke', 'currentColor')
      path.setAttribute('stroke-linecap', 'round')
      path.setAttribute('stroke-linejoin', 'round')
      path.setAttribute('stroke-width', '2')
      path.setAttribute('d', 'm1 1 4 4 4-4')
      
      svg.appendChild(path)
      button.appendChild(svg)
    }
    
    // Fechar dropdown
    const dropdown = document.getElementById('dropdownSearch')
    if (dropdown) {
      dropdown.classList.add('hidden')
    }
    
    // Atualizar data-serial no frame para próximas seleções
    const frame = document.getElementById('forecast_chart')
    if (frame) {
      frame.dataset.serial = serial
    }
  }
}


